<div class="aw-banner" *ngIf="!loading && items.length" (click)="open()">
  <div class="aw-ic"><mat-icon>campaign</mat-icon></div>
  <div class="aw-body">
    <div class="aw-top">
      <span class="aw-label">Announcements</span>
      <span class="aw-badge" *ngIf="unacknowledgedCount > 0">{{ unacknowledgedCount }} new</span>
    </div>
    <div class="aw-title">{{ latest?.title }}</div>
  </div>
  <button type="button" class="aw-view-btn" (click)="open(); $event.stopPropagation()">
    View All <mat-icon>chevron_right</mat-icon>
  </button>
</div>

<div class="aw-overlay" *ngIf="showModal" (click)="close()">
  <div class="aw-modal" (click)="$event.stopPropagation()">
    <div class="aw-modal-head">
      <div>
        <h3>Announcements</h3>
        <p>{{ items.length }} total · {{ unacknowledgedCount }} awaiting your acknowledgement</p>
      </div>
      <button type="button" class="aw-close" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="aw-modal-body">
      <div class="aw-item" *ngFor="let item of items" [class.aw-item--done]="item.acknowledged">
        <div class="aw-item-head">
          <span class="aw-p-tag" [ngClass]="priorityClass(item.priority)">{{ priorityLabel(item.priority) }}</span>
          <span class="aw-date">{{ item.createdAt | date:'MMM d, y, h:mm a' }}</span>
        </div>
        <div class="aw-item-title">{{ item.title }}</div>
        <div class="aw-item-content">{{ item.content }}</div>
        <div class="aw-item-foot">
          <span class="aw-ack-tag" *ngIf="item.acknowledged">
            <mat-icon>check_circle</mat-icon> Acknowledged {{ item.acknowledgedAt | date:'MMM d, h:mm a' }}
          </span>
          <button type="button" class="aw-ack-btn" *ngIf="!item.acknowledged"
                  [disabled]="acking[item.id]" (click)="acknowledge(item)">
            <mat-icon>{{ acking[item.id] ? 'hourglass_empty' : 'task_alt' }}</mat-icon>
            {{ acking[item.id] ? 'Recording…' : 'Acknowledge' }}
          </button>
        </div>
      </div>
      <div class="aw-empty" *ngIf="!items.length">No announcements yet.</div>
    </div>
  </div>
</div>
